<div id="driver-wizard"
     class="row ">
     <div class="d-flex justify-content-between align-items-center card-title"
          id="page-title">
          <h1 *ngIf="!service.justSubscribe"
              [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>

          <h1 *ngIf="service.justSubscribe"
              [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="6"
                                      [totalSteps]="11"></app-complete-bar>
                    <div class="overlay"
                         *ngIf="isLoading">
                         <h1 class="heading"
                             [innerHtml]="'Loading' | translator: 'base'">
                              Loading...
                         </h1>
                         <img [alt]="'Loading' | translator: 'base'" />
                    </div>
                    <h2 [innerHtml]="'Review' | translator: 'base'">Review</h2>
                    <div class="justify-content-md-center form-group form-inline">

                         <p class="step-text"
                            [innerHtml]="'PleaseReviewTitle' | translator: 'base'">
                              Please review the information entered.
                         </p>

                         <div class="row gx-2">
                              <fieldset>
                                   <legend class="h3 text-brand-dark"
                                           [innerHtml]="'ContactInformation' | translator: 'base'"
                                           [title]="'ContactInformation' | translator: 'base'">Review
                                   </legend>
                                   <table class="table table-vertical table-centered table-collapsible">
                                        <tbody>
                                             <tr>
                                                  <th scope="col"
                                                      [innerHtml]="'Name' | translator: 'base'"
                                                      [title]="'Name' | translator: 'base'">Name</th>
                                                  <td>
                                                       <span class="cell-label"
                                                             [innerHtml]="'Name' | translator: 'base'"></span>
                                                       <label>{{service.driverRequest.firstName}}&nbsp;</label>
                                                       <label>{{service.driverRequest.middleInitial}}&nbsp;</label>
                                                       <label>{{service.driverRequest.lastName}}&nbsp;</label>
                                                       <label>{{service.driverRequest.suffix}}&nbsp;</label>
                                                  </td>
                                             </tr>
                                             <tr>
                                                  <th scope="col"
                                                      [innerHtml]="'DOB' | translator: 'base'"
                                                      [title]="'DOB' | translator: 'base'">Date of Birth</th>
                                                  <td>
                                                       <span class="cell-label"
                                                             [innerHtml]="'DOB' | translator: 'base'">Date of
                                                            Birth</span>
                                                       <span>{{dateOfBirthDisplay}}</span>
                                                  </td>
                                             </tr>
                                             <tr>
                                                  <th scope="col"
                                                      [innerHtml]="'Email' | translator: 'base'"
                                                      [title]="'Email' | translator: 'base'">Email</th>
                                                  <td class="text-break">
                                                       <span class="cell-label"
                                                             [innerHtml]="'Email' | translator: 'base'">Email</span>
                                                       {{service.driverRequest.emailAddress}}
                                                  </td>
                                             </tr>
                                             <tr>
                                                  <th [innerHtml]="'Phone Number' | translator: 'base'"
                                                      [title]="'Phone Number' | translator: 'base'">Phone Number
                                                  </th>
                                                  <td>
                                                       <span class="cell-label"
                                                             [innerHtml]="'Phone Number' | translator: 'base'">Phone
                                                            Number</span>
                                                       {{service.driverRequest.address?.phoneNumber}}
                                                  </td>
                                             </tr>
                                             <tr>
                                                  <th [innerHtml]="'AltPhoneNumber' | translator: 'base'"
                                                      [title]="'AltPhoneNumber' | translator: 'base'">Alternate
                                                       Phone</th>
                                                  <td>
                                                       <span class="cell-label"
                                                             [innerHtml]="'AltPhoneNumber' | translator: 'base'">Alternate
                                                            Phone</span>
                                                       {{service.driverRequest.address?.altPhoneNumber ?? ''}}
                                                  </td>
                                             </tr>
                                             <tr>
                                                  <th [innerHtml]="'ContactAddress' | translator: 'base'"
                                                      [title]="'ContactAddress' | translator: 'base'">Contact
                                                       Address</th>

                                                  <td>
                                                       <span class="cell-label"
                                                             [innerHtml]="'ContactAddress' | translator: 'base'">Contact
                                                            Address</span>
                                                       <address>
                                                            {{service.driverRequest.address?.addressLine1}}
                                                            <br />
                                                            <span *ngIf="service.driverRequest.address?.addressLine2">
                                                                 {{service.driverRequest.address?.addressLine2}}
                                                                 <br />
                                                            </span>
                                                            {{service.driverRequest.address?.city}},
                                                            {{service.driverRequest.address?.state}}
                                                            <br />
                                                            {{service.driverRequest.address?.zip}}
                                                       </address>
                                                  </td>
                                             </tr>
                                        </tbody>
                                   </table>
                              </fieldset>
                              <fieldset>
                                   <legend class="h3 text-brand-dark"
                                           [innerHtml]="'LicenseInfo' | translator: 'base'"
                                           [title]="'LicenseInfo' | translator: 'base'">LICENSE INFORMATION</legend>

                                   <table class="table table-collapsible">
                                        <thead>
                                             <tr>
                                                  <th scope="col"
                                                      [innerHtml]="'LastName' | translator: 'base'"
                                                      name="Last-Name">Last Name</th>
                                                  <th scope="col"
                                                      [innerHtml]="'LicenseNumber' | translator: 'base'"
                                                      name="First-Name">License Number</th>
                                                  <th scope="col"
                                                      [innerHtml]="'LicenseState' | translator: 'base'"
                                                      name="License-State">License State</th>
                                             </tr>
                                        </thead>
                                        <tbody>
                                             <tr
                                                 *ngFor="let l of service.driverRequest.driversLicenses; let idx = index">
                                                  <td class="text-break">
                                                       <span class="cell-label"
                                                             [innerHtml]="'LastName' | translator: 'base'">Last
                                                            Name</span>
                                                       {{l.lastName}}
                                                  </td>
                                                  <td class="text-break">
                                                       <span class="cell-label"
                                                             [innerHtml]="'LicenseNumber' | translator: 'base'">License
                                                            Number</span>
                                                       {{l.licenseNumber}}
                                                  </td>
                                                  <td>
                                                       <span class="cell-label"
                                                             [innerHtml]="'LicenseState' | translator: 'base'">License
                                                            State</span>
                                                       {{l.state}}
                                                  </td>
                                             </tr>
                                        </tbody>
                                   </table>
                              </fieldset>
                              <fieldset>
                                   <legend class="h3 text-brand-dark"
                                           [innerHtml]="'DrAuthAndConf' | translator: 'base'">DRIVER AUTHORIZATION AND
                                        CONFIRMATION</legend>
                                   <p [innerHtml]="'DrAuthAndConfExplanation' | translator: 'base'"
                                      class="wrap">
                                        I certify under the penalty of purjury that I am requesting only my
                                        personal commercial driver crash and inspection history.
                                   </p>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio"
                                                    id="agree"
                                                    name="driverHasConsented"
                                                    class="form-check-input"
                                                    [(ngModel)]="this.service.driverRequest.driverHasConsented"
                                                    value="true"
                                                    [title]="'Agree' | translator: 'base'">
                                             <span [innerHtml]="'Agree' | translator: 'base'"
                                                   [title]="'Agree' | translator: 'base'">Agree</span>
                                        </label>
                                   </div>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input type="radio"
                                                    id="disagree"
                                                    name="driverHasConsented"
                                                    class="form-check-input"
                                                    [(ngModel)]="this.service.driverRequest.driverHasConsented"
                                                    value="false"
                                                    [title]="'Disagree' | translator: 'base'" />
                                             <span [innerHtml]="'Disagree' | translator: 'base'"
                                                   [title]="'Disagree' | translator: 'base'">Disagree</span>
                                        </label>
                                   </div>
                              </fieldset>

                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group"
                                        role="group">
                                        <button (click)="moveNext()"
                                                class="btn btn-primary btn-strong"
                                                [title]="this.continueButtonText"
                                                [disabled]="pageValid() === false"
                                                name="driverNext"
                                                id="driverNext">
                                             {{ this.continueButtonText }}
                                             <span class="sr-only">{{ this.continueButtonText }}</span>
                                        </button>
                                   </div>

                                   <div class="btn-group"
                                        role="group">
                                        <button [routerLink]="service.backLinkRoute(7)"
                                                (click)="scrollToTop()"
                                                class="btn btn-outline-primary"
                                                [title]="this.backButtonText"
                                                [innerHtml]="this.backButtonText"
                                                name="back7"
                                                id="back7">
                                             {{ this.backButtonText }}
                                        </button>

                                        <button [routerLink]="service.cancelLinkRoute()"
                                                tag="button"
                                                class="btn btn-light"
                                                (click)="scrollToTop()"
                                                name="driverCancel"
                                                id="driverCancel"
                                                [innerHtml]="'Cancel' | translator: 'base'"
                                                [title]="'Cancel' | translator: 'base'">
                                             Cancel
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="3"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>